module.exports = __webpack_public_path__ + "img/if_14.979e603f.png";